import React, { useEffect, useRef, useState } from "react";
import { FaRegCopy } from "react-icons/fa6";
import { useSelector } from "react-redux";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { SyncLoader } from 'react-spinners';
import apis from "../services";
import { showApiErrors } from "../utils";

const availableNetworks = [
    { name: "Ethereum Mainnet", chainId: 1 },
    { name: "Sepolia testnet", chainId: 11155111 },
    { name: "Polygon", chainId: 137 },
    { name: "Polygon Amoy", chainId: 80002 },
    { name: "BSC", chainId: 56 },
    { name: "BSC testnet", chainId: 97 },
    { name: "Avalanche C-Chain Mainnet", chainId: 43114 },
    { name: "Solana DevNet", chainId: 103 },
    { name: "Solana MainNet", chainId: 101 },
];

const TwoFactorModal = ({ isOpen, onClose }) => {

    const [otp, setOtp] = useState(["", "", "", ""]);
    const [timer, setTimer] = useState(39);
    const [isResendEnabled, setIsResendEnabled] = useState(false);
    const inputRefs = useRef([null, null, null, null]);
    const navigate = useNavigate(); // <-- Hook yahan bhi
    const { email } = useLocation().state || {};

    useEffect(() => {
        let interval;
        if (timer > 0) {
            interval = setInterval(() => setTimer(t => t - 1), 1000);
        } else {
            setIsResendEnabled(true);
        }
        return () => clearInterval(interval);
    }, [timer]);


    const handleChange = (index, value) => {
        if (!/^\d*$/.test(value)) return;
        const newOtp = [...otp];
        newOtp[index] = value.slice(-1);
        setOtp(newOtp);
        if (value && index < 3) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handleResend = async () => {
        setOtp(["", "", "", ""]);
        setTimer(39);
        setIsResendEnabled(false);
        try {
            const res = await apis.authRequestOtp({ email });
            console.log(res, "---");

        } catch (error) {
            showApiErrors(error, 'Something went wrong, please try again');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (otp.join("").length === 4) {
                const res = await apis.authVerifyOtp({ email, otp: otp.join("") });
                console.log(res, "---");
                navigate('/change-password', { state: { email, otp: res?.data?.otp }, replace: true });
            }
        } catch (error) {
            showApiErrors(error, 'Something went wrong, please try again');
        }

    };

    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <button className="newnetwork-back-button-select-network" onClick={onClose}>
                    &#8592;
                </button>
                <div className="">
                    <h2 className="login-title" style={{ textAlign: "center", marginBottom: 8 }}>
                        VERIFICATION
                    </h2>
                    <div style={{ textAlign: "center", color: "#c1c4d2", fontWeight: 400, marginBottom: 26 }}>
                        Enter Your 4 Digits Code That You Received On Your Email.
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="otp-inputs">
                            {otp.map((d, i) => (
                                <input
                                    key={i}
                                    ref={el => (inputRefs.current[i] = el)}
                                    type="text"
                                    maxLength={1}
                                    className="otp-box"
                                    value={d}
                                    onChange={e => handleChange(i, e.target.value)}
                                    onKeyDown={e => handleKeyDown(i, e)}
                                    inputMode="numeric"
                                    autoComplete="one-time-code"
                                />
                            ))}
                        </div>
                        {/* <div style={{ textAlign: "center", color: "#aaa", margin: "15px 0 7px 0", fontWeight: 500, fontSize: 16 }}>
            00:{timer < 10 ? `0${timer}` : timer}
          </div> */}
                        <button
                            className="login-btn"
                            type="submit"
                            disabled={otp.some(val => val === "")}
                            style={{
                                marginTop: 10,
                                marginBottom: 10,
                                cursor: otp.some(val => val === "") ? "not-allowed" : "pointer"
                            }}
                        >
                            Continue
                        </button>
                    </form>
                    <div style={{ textAlign: "center", color: "#c1c4d2", marginTop: 8, display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
                        Didn't Receive Code?
                        {
                            !isResendEnabled ? (
                                <div style={{ color: "#aaa", fontWeight: 500, fontSize: 16 }}>
                                    00:{timer < 10 ? `0${timer}` : timer}
                                </div>
                            ) : (
                                <span
                                    className="resend-link"
                                    onClick={isResendEnabled ? handleResend : undefined}
                                    style={{
                                        color: isResendEnabled ? "#fff" : "#b3b3b3",
                                        fontWeight: 700,
                                        marginLeft: 7,
                                        cursor: isResendEnabled ? "pointer" : "not-allowed",
                                        textDecoration: isResendEnabled ? "underline" : "none"
                                    }}
                                >
                                    Resend OTP
                                </span>
                            )
                        }

                    </div>
                </div>
            </div>
        </div>
    );
};

export default TwoFactorModal;
